'use client'

import { Button } from '@skop-app/lib-front'

import { useImpersonationControls } from '@/hooks/useImpersonationControls'
import { useSessionRuntime } from '@/context/SessionRuntimeContext'
import {
  selectUser,
  useLightUserById,
  useUser,
} from '@/services/user/user.query'

export function ImpersonationBanner() {
  const { currentUserId, isImpersonating } = useSessionRuntime()
  const { data: effectiveUser } = useUser(selectUser)
  const { data: actorUser } = useLightUserById(currentUserId)
  const { stopImpersonation } = useImpersonationControls()

  if (!isImpersonating || !effectiveUser) {
    return null
  }

  const actorLabel =
    actorUser?.email ??
    actorUser?.name ??
    currentUserId ??
    'Unknown session owner'

  return (
    <div className="border-b border-amber-300 bg-amber-50 px-4 py-2 text-amber-950">
      <div className="mx-auto flex w-full max-w-[1600px] items-center justify-between gap-4">
        <div className="min-w-0">
          <p className="text-sm font-semibold">Impersonation active</p>
          <p className="truncate text-sm">
            Session owner: {actorLabel}. Acting as: {effectiveUser.email}.
          </p>
        </div>
        <Button
          size="tiny"
          variant="outline"
          className="shrink-0 border-amber-400 bg-white text-amber-950 hover:bg-amber-100"
          onClick={() => {
            void stopImpersonation()
          }}
        >
          Stop impersonation
        </Button>
      </div>
    </div>
  )
}
